<template>
  <div class="_wrapper"
       @mouseover="isDropdownActive = true"
       @mouseleave="isDropdownActive = false"
  >
    <!-- Category link block -->
    <router-link class="dropdown-link no-underline" :to="categoryLink(item)">
      <div class="dropdown-link-content">
        <span class="dropdown-link-content-title"> {{ item.name }} </span>
      </div>
      <img src="../../../../../../assets/shop/nav-arrow.svg"
           class="dropdown-link-arrow"
           :class="{ 'is-hidden': !item.children_data || !item.children_data.length }"
           alt="arrow"
           width="8"
           height="13"
           loading="eager"
           fetchpriority="high"
      >
    </router-link>
    <!---->

    <!-- Category dropdown block -->
    <dropdown-block v-if="item.children_data && item.children_data.length && isDropdownActive"
                    :list="item.children_data"
                    :list-naming="item.name"
    />
    <!---->

  </div>
</template>

<script>
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import { mapGetters } from 'vuex'

export default {
  components: {
    DropdownBlock: () => import('theme/components/core/blocks/Shop/Navigation/Dropdown/DropdownBlock')
  },
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      isDropdownActive: false
    }
  },
  computed: {
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner'
    }),
    currentPartnerCode () {
      return this.currentPartner.code
    },
    currentLocationCode () {
      return this.$route.params.locationCode
    }
  },
  methods: {
    categoryLink (category) {
      return `/${this.currentLocationCode}/${this.currentPartnerCode}${formatCategoryLink(category)}`
    }
  }
}
</script>

<style lang="scss" scoped>
._wrapper {
  flex: 0 0 auto;
}

.dropdown-link {
  height: 20px;
  padding: 10px 0 10px 20px;

  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  transition: .2s;

  &:hover {
    cursor: pointer;
    background: #fff;
  }

  &-content {
    display: flex;
    align-items: center;
    overflow: hidden;

    &-title {
      color: #111;
      font-size: 14px;
      font-weight: 600;
      line-height: 15px;

      display: -webkit-box;
      /* autoprefixer: off */
      -webkit-box-orient: vertical;
      /* autoprefixer: on */
      -webkit-line-clamp: 2;
    }
  }

  &-arrow {
    padding: 0 20px;

    width: 10px;
    height: 14px;

    &.is-hidden {
      width: 0;
      height: 0;
    }
  }
}
</style>
